<template>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" @close="close" :close-on-click-modal="false" :close-on-press-escape="false" width="900px">
        <el-form size="small" :model="form" :rules="formRules" :label-width="formLabelWidth" ref="form">
            <el-form-item label="题型" prop="question_type">
                <el-radio-group v-model="form.question_type" @change="questionTypeChange">
                    <el-radio :label="1" >判断题</el-radio>
                    <el-radio :label="2" >单选题</el-radio>
                    <el-radio :label="3" >多选题</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="标题" prop="title">
                <el-input v-model="form.title" placeholder="标题" clearable/>
            </el-form-item>

            <el-form-item label="选项" prop="options">
                <el-button type="primary" @click="addOptions">新增选项</el-button>
            </el-form-item>
            <el-form-item label="" prop="options">
                <div class="options-item" v-for="(item, index) in options" :key="index">
                    <div class="options-item-1">{{ options[index].options }}</div>
                    <div class="options-item-3">
                        <el-input v-model="options[index].title" placeholder="选项内容" clearable/>
                    </div>
                    <div class="options-item-4">
                        <el-checkbox v-model="options[index].is_answer" :true-label="1" :false-label="0" @change="answerChange(item)">正确答案</el-checkbox>
                    </div>
                    <div class="options-item-5">
                        <el-button type="danger" icon="el-icon-delete" @click="delOption(item)"></el-button>
                    </div>
                </div>
            </el-form-item>

<!--            <el-form-item label="分数" prop="score">-->
<!--                <el-input-number v-model="form.score" @change="handleScoreChange" :min="1" :max="100" label="分数"></el-input-number>-->
<!--            </el-form-item>-->

            <el-form-item label="状态">
                <el-radio-group v-model="form.status">
                    <el-radio :label="1">启用</el-radio>
                    <el-radio :label="0">禁用</el-radio>
                </el-radio-group>
            </el-form-item>

<!--            <el-form-item label="备注" prop="remark">-->
<!--                <el-input v-model="form.remark" type="textarea" placeholder="备注" clearable/>-->
<!--            </el-form-item>-->


<!--            <el-form-item label="图片" prop="image_id">-->
<!--                <el-row>-->
<!--                    <el-button type="primary" @click="openUpload">选择图片</el-button>-->
<!--                    <div v-if="form.image_id !== ''" class="img">-->
<!--                        <img :src="file_path" width="100" height="100" />-->
<!--                    </div>-->
<!--                </el-row>-->
<!--            </el-form-item>-->
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="save" :disabled="submit_loading">确 定</el-button>
        </div>
        <!--上传图片组件-->
        <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
    </el-dialog>
</template>

<script>
    import { questionEdit, questionDetail } from '@/api/education';
    import Upload from '@/components/file/Upload';

    export default {
        components: { Upload },
        data() {
            return {
                title: '',
                form: {
                    question_id: '',
                    title: '',
                    question_type: 1,
                    score: 10,
                    options: [],
                    status: 1,
                },
                file_path: '',
                /*左边长度*/
                formLabelWidth: '120px',
                /*是否显示*/
                dialogFormVisible: false,
                /*是否正在提交*/
                submit_loading: false,
                /*链接选择*/
                is_linkset: false,
                // 验证
                formRules: {
                    title: [{
                        required: true,
                        message: '请输入标题名称',
                        trigger: 'blur'
                    }]
                },
                /*上传图片*/
                isupload: false,

                options: [], // 选项
                AZ: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'],

            };
        },
        props: ['fetch-data'],
        created() {

        },
        methods: {
            showDialog(row) {
                if (!row) {
                    this.title = '添加题目'
                } else {
                    this.title = '编辑题目'
                    this.form.question_id = row.question_id
                    this.getDetail()
                }
                this.dialogFormVisible = true
            },
            // 关闭
            close() {
                this.$refs['form'].resetFields()
                this.form = this.$options.data().form
                this.options = []
                this.dialogFormVisible = false
            },
            // 保存
            save() {
                this.$refs['form'].validate(async (valid) => {
                    if (valid) {
                        this.submit_loading = true
                        this.form.options = this.options
                        questionEdit(this.form).then((result)=>{
                            this.$message({message: result.msg, type: 'success'});
                            this.$emit('fetch-data')
                            this.submit_loading = false
                            this.close()
                        }).catch(()=>{
                            this.submit_loading = false
                        })
                    }
                })
            },
            getDetail(){
                questionDetail({id: this.form.question_id}).then((result)=>{
                    this.form = Object.assign({}, result.data)
                    this.options = result.data.option
                })
            },

            // 图片上传
            openUpload(e) {
                // this.type = e;
                this.isupload = true;
            },
            /*获取图片*/
            returnImgsFunc(e) {
                if (e != null && e.length > 0) {
                    this.file_path = e[0].file_path;
                    this.form.image_id = e[0].file_id;
                }
                this.isupload = false;
            },

            // 切换题目类型时
            questionTypeChange(val){
                this.options.map((item, index)=>{
                    this.options[index].is_answer = 0
                })
            },
            // 选择正确答案时
            answerChange(val){
                if(this.form.question_type < 3){ // 只能有一个正确答案
                    this.options.map((item, index)=>{
                        if(val.options === item.options){
                            this.options[index].is_answer = 1
                        }else {
                            this.options[index].is_answer = 0
                        }
                    })
                }
            },
            // 新增选项
            addOptions(){
                let options_length = this.options.length;
                if(options_length >= 8){
                    this.$message({type: 'error', message: '最多只能添加8个选项'});
                    return
                }
                this.options.push({ title: '', options: this.AZ[options_length], is_answer: 0 })
            },
            // 删除选项
            delOption(item){
                let index = this.options.indexOf(item)
                this.options.splice(index, 1)
                // 重新排序
                this.options.map((item, index)=>{
                    this.options[index].options = this.AZ[index]
                })
            },

        }
    };
</script>

<style scoped>
    .options-item{
        display: flex;
        flex-direction: row;
        margin-bottom: 5px;
    }
    .options-item-1{
        margin: 0 5px;
        font-size: 16px;
    }
    .options-item-2{
        width: 60px;
        margin-right: 5px;
    }
    .options-item-3{
        width: 600px;
    }
    .options-item-4{
        margin-left: 5px;
    }
    .options-item-5{
        margin-left: 5px;
    }
</style>



// WEBPACK FOOTER //
// src/views/education/question/edit.vue